import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OpportunitiesSection = ({ opportunities, onApplyClick }) => {
  return (
    <section className="py-12 lg:py-16 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Current Volunteer Opportunities
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Join our mission and make a real difference in your community
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {opportunities?.map((opportunity) => (
            <div
              key={opportunity?.id}
              className="bg-card rounded-xl p-6 shadow-md border border-border hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
                  <Icon name={opportunity?.icon} size={24} color="white" />
                </div>
                {opportunity?.urgent && (
                  <span className="px-2 py-1 bg-error/10 text-error text-xs font-semibold rounded-full">
                    Urgent
                  </span>
                )}
              </div>

              <h3 className="text-xl font-semibold text-foreground mb-2">
                {opportunity?.title}
              </h3>
              <p className="text-sm text-muted-foreground mb-4 line-clamp-3">
                {opportunity?.description}
              </p>

              <div className="space-y-2 mb-4">
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Icon name="MapPin" size={16} />
                  <span>{opportunity?.location}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Icon name="Calendar" size={16} />
                  <span>{opportunity?.schedule}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Icon name="Clock" size={16} />
                  <span>{opportunity?.commitment}</span>
                </div>
              </div>

              <div className="mb-4">
                <div className="text-xs font-medium text-muted-foreground mb-2">
                  Skills Needed:
                </div>
                <div className="flex flex-wrap gap-2">
                  {opportunity?.skills?.map((skill, index) => (
                    <span
                      key={index}
                      className="px-2 py-1 bg-secondary/10 text-secondary text-xs font-medium rounded"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>

              <div className="flex items-center justify-between pt-4 border-t border-border">
                <div className="text-sm">
                  <span className="font-semibold text-primary">{opportunity?.volunteers}</span>
                  <span className="text-muted-foreground"> volunteers needed</span>
                </div>
                <Button
                  variant="default"
                  size="sm"
                  onClick={() => onApplyClick(opportunity)}
                >
                  Apply
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <Button variant="outline" size="lg" iconName="Search" iconPosition="left">
            View All Opportunities
          </Button>
        </div>
      </div>
    </section>
  );
};

export default OpportunitiesSection;